// Contenedor mobile-only para listas que en escritorio son tabla. El llamador decide el
// contenido de cada tarjeta vía renderTarjeta (render-prop): este componente solo resuelve el
// contenedor y los 3 estados comunes a cualquier listado (cargando / vacío / con datos), para no
// repetirlos pantalla por pantalla. La paginación NO vive acá — cada pantalla sigue usando su
// propio <Pagination> de MUI debajo, tal como ya lo hace en escritorio.
export default function ListaTarjetas({
    items,
    loading,
    renderTarjeta,
    keyExtractor,
    textoVacio = 'Sin resultados',
    iconoVacio = 'bi-inbox',
}) {
    if (loading) {
        return (
            <div className="mob-estado-generico">
                <div className="spinner-border spinner-border-sm text-primary" role="status" />
                <span>Cargando…</span>
            </div>
        );
    }

    if (!items || items.length === 0) {
        return (
            <div className="mob-estado-generico">
                <i className={`bi ${iconoVacio}`} aria-hidden="true" />
                <span>{textoVacio}</span>
            </div>
        );
    }

    return (
        <div className="mob-lista-tarjetas">
            {items.map((item, indice) => (
                <div key={keyExtractor ? keyExtractor(item) : indice} className="mob-tarjeta">
                    {renderTarjeta(item)}
                </div>
            ))}
        </div>
    );
}
